export interface RuleDto {    
    id: string;    
    name: string;
    expression: string;
    concatType?: RuleConcatType;
    description:RuleDescription[];
    
}
export interface RuleDescription {    
    id?:string;
    languageId: string;    
    iso:string; //language iso
    description: string;
}

export enum RuleConcatType {
    OR = 'OR',
    AND = 'AND',
}
